import script from "./ForgotPasswordForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordForm.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPasswordForm.vue?vue&type=style&index=0&id=6d2d5720&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d2d5720"]])

export default __exports__